import React from "react";
import "./GlobalShimmer.css";   // ✅ import styles

interface ShimmerProps {
  width?: string | number;   // width of the shimmer
  height?: string | number;  // height of the shimmer
  borderRadius?: string | number; // rounded corners
  shape?: "rect" | "circle"; // shape type
  style?: React.CSSProperties; // custom inline styles
  className?: string;         // custom classes
}

const GlobalShimmer: React.FC<ShimmerProps> = ({
  width = "100%",
  height = "20px",
  borderRadius = "4px",
  shape = "rect",
  style = {},
  className = "",
}) => {
  return (
    <div
      className={`shimmer-loader ${className}`}
      style={{
        width,
        height,
        borderRadius: shape === "circle" ? "50%" : borderRadius,
        ...style,
      }}
    />
  );
};

export default GlobalShimmer;
